import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { initialVtLoadingViewState, VtLoadingViewState } from '@/components/common/vt-loading-view/vt-loading-view.model'
@Component
export default class VtLoadingView extends Vue {
    @Prop({ required: true }) readonly promise!: Promise<any>
    @Prop({ default: 750 }) readonly minTime!: number

    @Watch('promise')
    onPromiseChanged(newPromise: Promise<any>) {
        this.state.promise = new Promise((resolve, reject) => {
            this.$eventHub.$emit('vt-loading-view', true)
            setTimeout(() => {
                newPromise
                    .then((data) => resolve(data))
                    .catch((err: Error) => reject(err))
                    .finally(() => this.$eventHub.$emit('vt-loading-view', false))
            }, this.minTime)
        })
    }

    state: VtLoadingViewState
    constructor() {
        super()
        this.state = initialVtLoadingViewState()
    }

    mounted() {
        this.state.promise = this.promise
    }
}
